var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loader-fade"}},[_c('e-circular-loading',{class:_vm.loaderClass,attrs:{"width":_vm.loaderWidth,"size":_vm.loaderSize,"value":_vm.localShowLoader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }